<template>
    <div class="loader" v-if="this.pageLoading">
        <div class="loader-inner ball-scale-multiple">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div class="main" v-else>
        <div class="header_section">
            <div class="heading_hero" id="heading_hero">
                <div class="profile_section" id="profile_section">
                    <div class="avatar_section">
                        <div class="avatar-container" v-if="this.userAttributes.photoURL">
                            <img
                                :src="this.userAttributes.photoURL"
                                :dara-src="this.userAttributes.photoURL"
                                :alt="this.userAttributes.name"
                                class="avatar-pic lazyloaded"
                            />
                        </div>
                        <i class="icon-user" v-else></i>
                    </div>
                    <div class="user_info_section">
                        <h3 class="user_name" v-if="userName">{{ userName }}</h3>
                        <p class="user_interested_category">
                            <i class="icon-like"></i>
                            {{
                            user_interested_category ? " " + user_interested_category : " "
                            }}
                            <router-link
                                to="customize-interest"
                                v-if="!user_interested_category"
                                class="change_interest"
                            >{{ $t("Customize Your Intereset") }}</router-link>
                        </p>
                        <p class="user_bookmarked_total">
                            <i class="icon-heart"></i>
                            {{ " " + articleList.length }}
                            {{ $t("お気に入りの記事") }}
                        </p>
                    </div>
                </div>
                <!-- <div class="change_settings_section">
                    <router-link to="settings" class="change_settings_button">{{$t('header.user.settings_modification')}}</router-link>
                </div>-->
            </div>
        </div>

        <div class="tab_bar_section" id="tab_bar_section" ref="tabBarSection">
            <div class="tab">
                <a
                    class="tablinks active"
                    @click="tabSwitcher($event, 'myfeed')"
                    id="defaultOpen"
                >{{ $t("myfeed") }}</a>
                <a class="tablinks" @click="tabSwitcher($event, 'favorite')">
                    {{
                    $t("お気に入りの記事")
                    }}
                </a>
                <a class="tablinks" @click="tabSwitcher($event, 'favoritePlaces')">
                    {{
                    $t("Favorite Places")
                    }}
                </a>
            </div>
        </div>

        <div class="container">
            <section class="content-wrap top__article">
                <div id="favorite" class="tabcontent">
                    <div class="loader" v-if="this.dataloading">
                        <div class="loader-inner ball-scale-multiple">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div v-else class="set-itemList">
                        <ul class="c-horizontalList" v-if="clipList.length">
                            <li
                                class="c-post"
                                :data-article-id="article.article_id"
                                v-for="(article, index) in clipList"
                                :key="index"
                            >
                                <div class="thumb c-ratioBox" style="padding-bottom: 62.5%">
                                    <a
                                        class="btnFav active"
                                        id="btnFav"
                                        href="javascript:;"
                                        @click="removeBookmark(article.article_id, $event)"
                                    ></a>
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        $store.state.languageName +
                        '/' +
                        article.article_id
                    "
                                        class="c-imageLink"
                                    >
                                        <img
                                            class="lazyloaded"
                                            :data-src="article.image.small"
                                            :alt="article.title"
                                            :src="article.image.small"
                                        />
                                    </a>
                                </div>
                                <div class="content">
                                    <h3 class="title">
                                        <a
                                            :href="
                        constants.MATCHA_MEDIA_SSL_URL +
                          $store.state.languageName +
                          '/' +
                          article.article_id
                      "
                                        >{{ article.title }}</a>
                                    </h3>
                                    <a
                                        v-if="article.region.child"
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        $store.state.languageName +
                        '/list/?region=' +
                        article.region.child.id +
                        '&category=all'
                    "
                                    >
                                        <p class="meta meta-place">{{ article.region.child.name }}</p>
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <ul v-else class="no-clip">
                            <img
                                src="https://resources.matcha-jp.com/static_resources/user/no-clip-matchan.webp"
                                class="lazyloaded"
                            />
                            <h3 class="empty-artcile">{{ $t("お気に入りの記事はありません") }}</h3>
                            <p>
                                {{
                                $t("気に入った記事をどんどんお気に入り登録していきましょう！")
                                }}
                            </p>
                            <a
                                :href="constants.MATCHA_SITE + languageName"
                                class="btn btn-green"
                            >{{ $t("記事を探す") }}</a>
                        </ul>
                    </div>
                    <!-- <div class="paginate-table" v-if="articleList.length > 12"> -->
                    <paginate
                        v-if="articleList.length > 11"
                        v-model="page"
                        :page-count="Math.ceil(articleList.length / 12)"
                        :page-range="5"
                        :margin-pages="0"
                        :click-handler="favorite_paginate_processor"
                        :prev-text="''"
                        :next-text="''"
                        :container-class="'c-pagination'"
                        :page-class="'page-item'"
                        :prev-link-class="'paginationPrevBtn'"
                        :next-link-class="'paginationNextBtn'"
                        :disabled-class="'disable'"
                        :active-class="'active'"
                        :initial-page="1"
                    ></paginate>
                </div>

                <div id="myfeed" class="tabcontent" style="display: block;">
                    <div class="notice-info" v-if="!this.category_notifier">
                        <div class="notice-icon">
                            <span class="icon-trouble"></span>
                        </div>
                        <div class="notice-content">
                            <a 
                                :href="`${constants.MATCHA_MEDIA_SSL_URL}${this.$i18n.locale}/9697`"
                                target="_blank"
                                @click="notificationViewd()" >
                                {{$t('Notice: Please re-register in accordance to an update of the feed function.')}}
                            </a>
                        </div>
                        <div class="notice-close" @click="notificationViewd()">
                            <span class="icon-closed">✕</span>
                        </div>
                    </div>


                    <div class="loader" v-if="this.feedLoading">
                        <div class="loader-inner ball-scale-multiple">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div v-else class="set-itemList">
                        <ul class="c-horizontalList" v-if="interested_articles_list.length > 0">
                            <li
                                class="c-post"
                                :data-article-id="article.article_id"
                                v-for="(article, index) in interested_articles_list"
                                :key="index"
                            >
                                <div class="thumb c-ratioBox" style="padding-bottom: 62.5%">
                                    <a
                                        v-bind:class="
                      isBookmarked(article.article_id)
                        ? 'active btnFav'
                        : 'btnFav'
                    "
                                        id="btnFav"
                                        href="javascript:;"
                                        @click="toggleBookmark(article.article_id, $event, article)"
                                    ></a>
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        $store.state.languageName +
                        '/' +
                        article.article_id
                    "
                                        class="c-imageLink"
                                    >
                                        <img
                                            class="lazyloaded"
                                            :data-src="article.image.small"
                                            :alt="article.title"
                                            :src="article.image.small"
                                        />
                                    </a>
                                </div>
                                <div class="content">
                                    <h3 class="title">
                                        <a
                                            :href="
                        constants.MATCHA_MEDIA_SSL_URL +
                          $store.state.languageName +
                          '/' +
                          article.article_id
                      "
                                        >{{ article.title }}</a>
                                    </h3>
                                    <a
                                        v-if="article.region.child"
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        $store.state.languageName +
                        '/list/?region=' +
                        article.region.child.id +
                        '&category=all'
                    "
                                    >
                                        <p class="meta meta-place">{{ article.region.child.name }}</p>
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <ul v-else class="no-clip">
                            <img
                                src="https://resources.matcha-jp.com/static_resources/user/no-clip-matchan.webp"
                                class="lazyloaded"
                            />
                            <h3 class="empty-artcile">{{ $t("no_articles") }}</h3>
                            <p>{{ $t("Customize Your Intereset") }}</p>
                            <router-link to="customize-interest" class="anchor-button">
                                {{
                                $t("変更する")
                                }}
                            </router-link>
                        </ul>
                    </div>

                    <paginate
                        v-if="interested_articles_total > 12"
                        v-model="page"
                        :page-count="Math.ceil(interested_articles_total / 12)"
                        :page-range="5"
                        :margin-pages="0"
                        :click-handler="feed_paginate_processor"
                        :prev-text="''"
                        :next-text="''"
                        :container-class="'c-pagination'"
                        :page-class="'page-item'"
                        :prev-link-class="'paginationPrevBtn'"
                        :next-link-class="'paginationNextBtn'"
                        :disabled-class="'disable'"
                        :active-class="'active'"
                        :initial-page="1"
                    ></paginate>
                </div>

                <div id="favoritePlaces" class="tabcontent">
                    <div class="loader" v-if="this.placeDataloading">
                        <div class="loader-inner ball-scale-multiple">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div v-else class="set-itemList">
                        <ul class="c-horizontalList" v-if="placeClipList.length">
                            <li
                                class="c-post"
                                :data-article-id="place.id"
                                v-for="(place, index) in placeClipList"
                                :key="index"
                            >
                                <div class="thumb c-ratioBox" style="padding-bottom: 62.5%">
                                    <a
                                        class="btnFav active"
                                        id="btnFav"
                                        href="javascript:;"
                                        @click="removePlaceIdsBookmark(place.id, $event)"
                                    ></a>
                                    <a
                                        :href="
                      constants.MATCHA_MEDIA_SSL_URL +
                        $store.state.languageName +
                        '/place/' +
                        place.id
                    "
                                        class="c-imageLink"
                                    >
                                        <img
                                            class="lazyloaded"
                                            :data-src="
                        place.matcha_data.thumbnail
                          ? place.matcha_data.thumbnail
                          : place.thumbnail
                      "
                                            :alt="place.title"
                                            :src="
                        place.matcha_data.thumbnail
                          ? place.matcha_data.thumbnail
                          : place.thumbnail
                      "
                                        />
                                    </a>
                                </div>
                                <div class="content">
                                    <h3 class="title">
                                        <a
                                            :href="
                        constants.MATCHA_MEDIA_SSL_URL +
                          $store.state.languageName +
                          '/place/' +
                          place.id
                      "
                                        >
                                            {{
                                            place.matcha_data.title
                                            ? place.matcha_data.title
                                            : place.title
                                            }}
                                        </a>
                                    </h3>
                                </div>
                            </li>
                        </ul>
                        <ul v-else class="no-clip">
                            <img
                                src="https://resources.matcha-jp.com/static_resources/user/no-clip-matchan.webp"
                                class="lazyloaded"
                            />
                            <h3 class="empty-artcile">{{ $t("お気に入りのスポットはありません") }}</h3>
                            <p>{{ $t("Feel free to bookmark your favorite places!") }}</p>
                            <a
                                :href="constants.MATCHA_SITE + languageName"
                                class="btn btn-green"
                            >{{ $t("記事を読んで、スポットを探そう！") }}</a>
                        </ul>
                    </div>

                    <!-- <div class="paginate-table" v-if="placeList.length > 12"> -->
                    <paginate
                        v-if="placeList.length > 11"
                        v-model="page"
                        :page-count="Math.ceil(placeList.length / 12)"
                        :page-range="5"
                        :margin-pages="0"
                        :click-handler="place_paginate_processor"
                        :prev-text="''"
                        :next-text="''"
                        :container-class="'c-pagination'"
                        :page-class="'page-item'"
                        :prev-link-class="'paginationPrevBtn'"
                        :next-link-class="'paginationNextBtn'"
                        :disabled-class="'disable'"
                        :active-class="'active'"
                        :initial-page="1"
                    ></paginate>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import clipsapi from "@/api/clip";
import articles from "@/api/articles";
import * as constants from "@/constants";
import Paginate from "@/components/Paginate";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import {
    getCategoryLists,
    getInterestList,
    getInterestBasedArticles
} from "@/api/user-interest";
import favPlace from "@/api/clip_place";

export default {
    mounted() {
        // Refresh state data
        this.$store
            .dispatch("updateUser")
            .then(res => {
                this.userName =
                    this.userMeta.user_first_name &&
                    this.userMeta.user_family_name
                        ? `${this.userMeta.user_first_name} ${this.userMeta.user_family_name}`
                        : this.userMeta.user_nickname
                        ? this.userMeta.user_nickname
                        : this.userAttributes.name;

                // Get All Category List And Assign to Computed Data
                const feed_Data = new Promise((resolve, reject) => {
                    // Get ALl Category List With Category Info [ex: title, id]
                    getCategoryLists({ lang_id: this.lang_id })
                        .then(response => {
                            this.$store.dispatch("setMatcaCategoryList", response.data);

                            /**
                             * Get User Interest List And Assign to Computed Data
                             * Category Id Only
                             * */

                            getInterestList(this.token)
                                .then(res => {
                                    this.$store.dispatch(
                                        "setUserInterestList",
                                        res
                                    );
                                    this.$store.dispatch(
                                        "setUserInterestedCategory",
                                        {
                                            response,
                                            res
                                        }
                                    );

                                    /**
                                     * Get Articles list for My Feed Based on User Interested Category
                                     */
                                    if (res.length > 0) {
                                        let arg_params = {
                                            lang_id: this.lang_id,
                                            type: "latest",
                                            page: this.page,
                                            data_limit: 12
                                        };

                                        getInterestBasedArticles(
                                            res,
                                            arg_params
                                        )
                                            .then(result => {
                                                this.interested_articles_total =
                                                    result.data.total_result;
                                                this.interested_articles_list =
                                                    result.data.articles_list;
                                                this.metaLoading = false;
                                                resolve({ res, result });
                                            })
                                            .catch(err => {
                                                this.metaLoading = false;
                                                reject(err);
                                            });
                                    } else {
                                        this.metaLoading = false;
                                        resolve(res);
                                    }
                                })
                                .catch(error => {
                                    this.metaLoading = false;
                                    reject(error);
                                });
                        })
                        .catch(err => {
                            this.metaLoading = false;
                            reject(err);
                        });
                });

                /**
                 * Get User Bookmarked Articles List
                 */
                const favorite_data = new Promise((resolve, reject) => {
                    clipsapi
                        .getClipList(this.token)
                        .then(result => {
                            if (
                                result.status == 200 &&
                                result.data.length > 0
                            ) {
                                let kijilist = result.data;

                                this.bookmarked_articles_id = result.data;

                                if (kijilist.length > 0) {
                                    let param = {
                                        lang_id:
                                            this.lang_id !== 0
                                                ? this.lang_id
                                                : 2,
                                        article_ids: kijilist.join(",")
                                    };

                                    articles
                                        .getArticles(param)
                                        .then(res => {
                                            if (res.data.data) {
                                                this.$store.dispatch(
                                                    "getArticlesDetails",
                                                    res.data.data
                                                );
                                                this.dataloading = false;
                                                resolve(res.data.data);
                                            } else {
                                                this.dataloading = false;
                                                resolve([]);
                                            }
                                        })
                                        .catch(err => {
                                            this.dataloading = false;
                                            reject(err);
                                        });
                                } else {
                                    this.dataloading = false;
                                }
                            } else {
                                this.dataloading = false;
                                resolve(result);
                            }
                        })
                        .catch(err => {
                            reject(err);
                        });
                });

                // Get Feed, Bookmarked Data
                Promise.all([feed_Data, favorite_data])
                    .then(values => {
                        // console.info(values)
                        this.clipList = this.getClipList(1);
                        this.pageLoading = false;
                    })
                    .catch(err => {
                        this.pageLoading = false;
                        this.$swal({
                            text: this.$t("Error occuured Try after sometimes"),
                            type: "error"
                        });
                    });
            })
            .catch(err => {
                if (err.code && err.code === 403) {
                    this.pageLoading = false;
                    this.$swal({
                        text: this.$t(err.message),
                        type: "error"
                    }).then(() => {
                        this.$store.dispatch("logout");
                    });
                } else {
                    this.pageLoading = false;
                    this.$swal({
                        text: this.$t("Error occuured Try after sometimes"),
                        type: "error"
                    });
                }
            });

        /**
         * Get User Bookmarked Place Ids List
         * getPlaceDeatils
         */
        // console.log(this.token);
        // console.log(this.$store.state.user.token);
        // console.log(token);

        favPlace
            .getClipedPlaceLists(this.token || this.$store.state.user.token)
            .then(result => {
                // console.log(result);
                if (result.status == 200 && result.data.length > 0) {
                    let bookmarked_places = result.data;
                    this.bookmarked_place_id = bookmarked_places;

                    if (bookmarked_places.length > 0) {
                        let lang_code = this.languageName
                            ? this.languageName
                            : "en";

                        favPlace
                            .getPlaceDeatils(bookmarked_places, lang_code)
                            .then(data => {
                                // console.log(data);
                                this.$store.dispatch("getPlaceDetails", data);
                                this.placeClipList = this.getPlaceClipList(1);
                                this.placeDataloading = false;
                            });
                    }
                } else {
                    this.placeDataloading = false;
                }
            })
            .catch(err => {
                this.placeDataloading = false;
                // console.log(err.response);
            });

        // Get All Clip Category
        // this.$store.dispatch("getAllClipCategory", this.token);

        // For Send Data to Google Tag manager
        this.$gtm.trackView("BookmarkedArticleLists", "currentpath");
    },

    data() {
        return {
            category_notifier: window.localStorage.getItem('Category_Notifier_Read'),
            clipList: [],
            placeClipList: [],
            constants: constants,
            pageLoading: true,
            dataloading: true,
            placeDataloading: true,
            metaLoading: true,
            feedLoading: false,
            page: 1,
            languageName: this.$store.state.languageName,
            interested_articles_total: [],
            interested_articles_list: [],
            bookmarked_articles_id: [],
            bookmarked_place_id: [],
            userName: "",
            place_fav_page: 1,
            fav_page: 1,
            feed_page: 1,
            error: []
        };
    },
    computed: {
        ...mapState(["clips", "user"]),
        ...mapGetters({
            email: "email",
            token: "token",
            lang_id: "languageId",
            dataList: "articleList",
            clip_category_id: "userClipCategory",
            articleList: "articleList",
            placeList: "placeList",
            userAttributes: "userAttributes",
            userMeta: "userMeta",
            user_interest_list: "userInterestList",
            user_interested_category: "userInterestedCategory"
        }),
        ...mapActions({
            removeArticleFromStore: "removeArticleFromStore",
            addArticleToStore: "addArticleToStore"
        })
    },
    components: { Paginate },
    methods: {
        isBookmarked(id) {
            return this.bookmarked_articles_id.indexOf(id) >= 0;
        },

        tabSwitcher(evt, tabName) {
            // console.log(evt)
            var i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("tablinks");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(
                    " active",
                    ""
                );
            }
            document.getElementById(tabName).style.display = "block";
            evt.currentTarget.className += " active";
        },

        toggleBookmark(id, event, article) {
            if (this.isBookmarked(id)) {
                //Remove
                let params = {
                    article_id: id,
                    clip_category_id: this.clip_category_id
                };

                clipsapi
                    .removeFromFavorite(params, this.token)
                    .then(result => {
                        if (result.status === 200) {
                            if (process.env.NODE_ENV === "production") {
                                clipsapi
                                    .decreaseArticleFavoriteCount({
                                        article_id: id,
                                        lang_id: this.lang_id
                                    })
                                    .then(res => {
                                        // console.log(res);
                                    });
                            }

                            this.$store.dispatch("removeArticleFromStore", id);
                            if (this.bookmarked_articles_id.indexOf(id) >= 0) {
                                let index = this.bookmarked_articles_id.indexOf(
                                    id
                                );
                                this.bookmarked_articles_id.splice(index, 1);
                            }
                        } else {
                            this.$swal({
                                type: "error",
                                title: this.$t("Oops..."),
                                text: this.$t("Article un-clip failure!")
                            });
                        }
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: this.$t("Oops..."),
                            text: this.$t("Article un-clip failure!")
                        });
                    });
            } else {
                // add
                clipsapi
                    .addArticleToFavorite(
                        { articleId: id, lang_id: this.lang_id },
                        this.token
                    )
                    .then(res => {
                        if (process.env.NODE_ENV === "production") {
                            clipsapi
                                .increaseArticleFavoriteCount({
                                    article_id: id,
                                    lang_id: this.lang_id
                                })
                                .then(result => {
                                    // console.log(result);
                                });
                        }

                        // console.log(res);
                        this.bookmarked_articles_id.push(id);
                        this.$store.dispatch("addArticleToStore", article);
                    })
                    .catch(err => {
                        // console.log(err)
                        this.$swal({
                            title: this.$t("Article clipped failure!"),
                            text: this.$t("Error occuured Try after sometimes"),
                            icon: "warning",
                            button: "OK"
                        });
                    });
            }
        },

        removeBookmark(id, event) {
            var e = event.target;
            var parentList = e.parentElement.parentElement;
            parentList.classList.add("list-leave-loading");

            this.$swal({
                title: this.$t("Are you sure?"),
                text: this.$t(
                    "This article will remove from your bookmark lists."
                ),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.deleteArticleFromApi(id, event);
                } else {
                    parentList.classList.remove("list-removed");
                    parentList.classList.remove("list-leave-loading");
                }
            });
        },

        removePlaceIdsBookmark(id, event) {
            var e = event.target;
            var parentList = e.parentElement.parentElement;
            parentList.classList.add("list-leave-loading");

            favPlace
                .removePlaceIdClip(id, this.token)
                .then(res => {
                    if (res.status === 200) {
                        setTimeout(() => {
                            this.$store.dispatch("removePlaceIdFromStore", id);
                            this.place_paginate_processor(
                                this.place_fav_page,
                                true
                            );
                            parentList.classList.remove("list-removed");
                            parentList.classList.remove("list-leave-loading");
                        }, 600);
                    } else {
                        parentList.classList.remove("list-removed");
                        parentList.classList.remove("list-leave-loading");
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: this.$t("Oops..."),
                        text: this.$t("Unable to remove bookmark!")
                    });
                    parentList.classList.remove("list-removed");
                    parentList.classList.remove("list-leave-loading");
                });
        },

        deleteArticleFromApi(id, event) {
            let e = event.target,
                parentList = e.parentElement.parentElement,
                params = {
                    article_id: id,
                    clip_category_id: this.clip_category_id
                };

            clipsapi
                .removeFromFavorite(params, this.token)
                .then(result => {
                    if (result.status === 200) {
                        if (process.env.NODE_ENV === "production") {
                            clipsapi
                                .decreaseArticleFavoriteCount({
                                    article_id: id,
                                    lang_id: this.lang_id
                                })
                                .then(res => {
                                    console.log(res);
                                });
                        }

                        parentList.classList.add("list-removed");
                        var timeout;
                        let self = this;
                        setTimeout(() => {
                            self.$store.dispatch("removeArticleFromStore", id);

                            if (this.bookmarked_articles_id.indexOf(id) >= 0) {
                                let index = this.bookmarked_articles_id.indexOf(
                                    id
                                );
                                this.bookmarked_articles_id.splice(index, 1);
                            }

                            self.favorite_paginate_processor(
                                self.fav_page,
                                true
                            );
                            parentList.classList.remove("list-removed");
                            parentList.classList.remove("list-leave-loading");
                        }, 600);
                    } else {
                        this.$swal({
                            type: "error",
                            title: this.$t("Oops..."),
                            text: this.$t("Article un-clip failure!")
                        });
                        parentList.classList.remove("list-removed");
                        parentList.classList.remove("list-leave-loading");
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: this.$t("Oops..."),
                        text: this.$t("Article un-clip failure!")
                    });
                    parentList.classList.remove("list-removed");
                    parentList.classList.remove("list-leave-loading");
                });
        },

        getClipList(page_number) {
            // console.log(page_number)
            if (this.articleList.length > 12) {
                --page_number;
                return this.articleList.slice(
                    page_number * 12,
                    (page_number + 1) * 12
                );
            } else {
                return this.articleList;
            }
        },

        getPlaceClipList(page_number) {
            if (this.placeList.length > 12) {
                --page_number;
                return this.placeList.slice(
                    page_number * 12,
                    (page_number + 1) * 12
                );
            } else {
                return this.placeList;
            }
        },

        favorite_paginate_processor(page, noscroll) {
            if (noscroll === undefined) {
                window.scroll(0, 0);
            }
            this.fav_page = page;
            this.clipList = this.getClipList(page);
        },

        place_paginate_processor(page, noscroll) {
            if (noscroll === undefined) {
                window.scroll(0, 0);
            }
            this.place_fav_page = page;
            this.placeClipList = this.getPlaceClipList(page);
        },

        myFeedDataMoreData(page) {
            this.feedLoading = true;

            let arg_params = {
                lang_id: this.lang_id,
                type: "latest",
                page: page,
                data_limit: 12
            };

            // Get User Interest List And Assign to Computer Data
            if (this.user_interest_list.length > 0) {
                getInterestBasedArticles(this.user_interest_list, arg_params)
                    .then(result => {
                        // console.log(result)
                        this.interested_articles_total =
                            result.data.total_result;
                        this.interested_articles_list =
                            result.data.articles_list;
                        this.feedLoading = false;
                    })
                    .catch(err => {
                        // console.log(err)
                        this.feedLoading = false;
                    });
            } else {
                // console.log(error)
                this.feedLoading = false;
            }
        },

        feed_paginate_processor(page) {
            window.scroll(0, 0);
            this.feed_page = page;
            this.myFeedDataMoreData(page);
        },

        notificationViewd(){
            window.localStorage.setItem('Category_Notifier_Read', true)
            this.category_notifier = true;
        }

    },

    // For Meta & Header Tag
    metaInfo() {
        return {
            title:
                this.$t("お気に入りの記事") +
                " | MATCHA - JAPAN TRAVEL WEB MAGAZINE",
            htmlAttrs: {
                lang: this.languageName
            },
            description: this.$t("footer.guide_text_short")
        };
    }
};
</script>
<style>
.list-leave-loading /* .list-leave-active below version 2.1.8 */ {
    opacity: 0.5;
}
.list-removed {
    transition: all 0.4s ease-out;
    opacity: 0;
    height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue